export default "__VITE_ASSET__CFVBHTV7__"